const desktopApi = () => window.electronAPI;

export const isElectron = () =>
  typeof window !== "undefined" && typeof window.electronAPI !== "undefined";

export const openExternalUrl = async (url) => {
  if (isElectron()) return desktopApi().external.open(url);
  window.location.assign(url);
  return true;
};

export const saveBinaryFile = async ({ suggestedName, mimeType, data }) => {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  if (isElectron()) {
    return desktopApi().files.save({ suggestedName, mimeType, data: bytes });
  }

  const blob = new Blob([bytes], { type: mimeType });
  const objectUrl = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = suggestedName;
    link.click();
    return { canceled: false };
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  }
};

export const openPrinterHelper = async (token) => {
  if (isElectron()) return desktopApi().printer.openHelper(token);
  window.location.assign(`printerhelper://open?token=${encodeURIComponent(token)}`);
  return true;
};

export const listPrinters = async () => {
  if (!isElectron()) return [];
  return desktopApi().printer.list();
};

export const getPrinterSettings = async () => {
  if (!isElectron()) return null;
  return desktopApi().printer.getSettings();
};

export const savePrinterSettings = async (settings) => {
  if (!isElectron()) throw new Error("Native printer settings require Orderly Desktop");
  return desktopApi().printer.saveSettings(settings);
};

export const clearPrinterSettings = async () => {
  if (!isElectron()) return;
  await desktopApi().printer.clearSettings();
};

export const printPrinterTest = async () => {
  if (!isElectron()) {
    return { submitted: false, message: "Native printer testing requires Orderly Desktop" };
  }
  return desktopApi().printer.test();
};

export const printThermalReceipt = async (request) => {
  if (!isElectron()) throw new Error("Native receipt printing requires Orderly Desktop");
  return desktopApi().printer.print(request);
};

export const probePrinter = async ({ host, port }) => {
  if (isElectron()) return desktopApi().printer.probe({ host, port });

  const hostForUrl = host.includes(":") ? `[${host}]` : host;
  const baseUrl = `http://${hostForUrl}:${port}`;
  try {
    const response = await fetch(`${baseUrl}/health`, {
      method: "GET",
      cache: "no-store",
      signal: AbortSignal.timeout(5000)
    });
    return response.ok
      ? { reachable: true, baseUrl }
      : { reachable: false, message: `Printer returned HTTP ${response.status}` };
  } catch {
    return { reachable: false, message: "Printer helper did not respond" };
  }
};

export const getNativeNetworkStatus = async () => {
  if (isElectron()) return desktopApi().network.isOnline();
  return navigator.onLine;
};

export const showNativeNotification = async ({ title, body }) => {
  if (isElectron()) return desktopApi().notifications.show({ title, body });
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") {
    new Notification(title, { body });
    return true;
  }
  return false;
};

export const createSecureState = () => {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
};
